import React, { Component } from 'react';

import { api } from '../../../services';

import Leads from './Leads';
import LeadsStatusSummary from './LeadsStatusSummary';
import LeadsSummary from './LeadsSummary';

import './Dashboard.css';
import {disposeOnUnmount, inject, observer} from 'mobx-react';
import {reaction} from "mobx";

@inject('leadsStore', 'commonStore')
@observer
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leadsSummaryLoading: false,
      leadsStatusSummaryLoading: false,
      leadsLoading: false,
      leadsSummary: {},
      leadsStatusSummary: {},
      leads: []
    };
  }

  loadData = () => {
    this.props.leadsStore.load();

    this.setState({ leadsSummaryStatusLoading: true }, () =>
      api('leadsStatusSummary', this.props.commonStore.selectedDealers).then(leadsStatusSummary => {
        this.setState({ leadsStatusSummary, leadsStatusSummaryLoading: false });
      })
    );
  }

  componentDidMount() {
    disposeOnUnmount(this, reaction(
      () => this.props.commonStore.selectedDealers,
      () => this.loadData(),
      {
        fireImmediately: true
      }
    ));


    this.interval = setInterval(() => {
      this.loadData()
    }, 300000);
  }

  componentWillUnmount = () => {
    clearInterval(this.interval);
  };

  render() {
    const { leadsStore } = this.props;
    let marginBottom = '25px';
    return (
      <div className="Dashboard">
        <LeadsSummary loading={this.state.leadsSummaryLoading} data={this.state.leadsSummary} style={{ marginBottom }} />
        <LeadsStatusSummary loading={this.state.leadsStatusSummaryLoading} data={this.state.leadsStatusSummary} style={{ marginBottom }} />
        <Leads loading={leadsStore.loading} data={leadsStore.filtered} />
      </div>
    );
  }
}

export default Dashboard;
